
  import SectionTitle from '@/common/components/redesigned/SectionTitle/SectionTitle.vue';

  export default {
    name: 'IndicatorsWrapper',
    components: { SectionTitle },
    props: {
      list: {
        type: Array,
        default: () => [],
      },
      title: {
        type: String,
        default: '',
      },
      source: {
        type: String,
      },
    },
  };
